import artifact from '$houdini/artifacts/SetUserSetting'
import { MutationStore } from '../runtime/stores/mutation'

export class SetUserSettingStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
